module.exports = __webpack_public_path__ + "static/media/news-d2.57eb25d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news-d2.mp4
// module id = Oo3r
// module chunks = 1